/**
 * Chart color roles. The severity ramp is an ordinal single-hue (brand green)
 * ramp validated with the dataviz palette validator on 2026-07-24:
 * monotone lightness, adjacent ΔL ≥ 0.06, light end 2.49:1 on #ffffff,
 * hue spread 1°. Darker = more severe. Re-validate before changing any step.
 *
 * Validated against light surfaces ONLY — #ffffff cards on #f5f5f7/#fbfbfd.
 * These values must not be carried onto a dark surface: the encoding inverts.
 * On #ffffff the ramp runs 2.49:1 → 3.71:1 → 6.56:1, so salience rises with
 * severity; on the corpus's dark page (#0b0f0e) the same colours run 7.75:1 →
 * 5.19:1 → 2.94:1, which makes `urgent` the *least* visible bar on the chart
 * and puts it under the 3:1 floor WCAG 2.1 SC 1.4.11 sets for non-text
 * graphics. Adopting a dark charted surface therefore requires re-deriving the
 * ramp, not re-theming around it. See the light-only decision.
 */
export const severityRamp = {
  routine: '#6fb28e',
  high: '#3f946a',
  urgent: '#0e6b43',
} as const;

/** Sparkline chrome: history in de-emphasis gray, current point in accent. */
export const sparklineColors = {
  history: '#c7c7cc',
  accent: '#0e6b43',
} as const;
